import { useState } from "react";
import { Button, HeaderMark } from "@repo/o37-ui";

const API_URL = import.meta.env.DEV ? "http://localhost:3001/api" : "/api";


export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setMessage("");
    setLoading(true);

    try {
      const response = await fetch(`${API_URL}/auth/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (response.ok) {
        setMessage(data.message);
        setEmail("");
      } else {
        setError(data.error || "Failed to send reset link");
      }
    } catch (err) {
      setError("Failed to send reset link. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="min-h-screen bg-white text-black flex flex-col">
      <HeaderMark />

      <section className="flex-1 flex items-center justify-center px-6 sm:px-12">
        <div className="w-full max-w-xl">
          <div className="rounded-2xl border border-neutral-200 p-10">
            <h1 className="text-3xl font-semibold mb-3">Reset Password</h1>
            <p className="text-neutral-600 text-base mb-8">
              Enter your email address and we'll send you a link to reset your password
            </p>

            <form onSubmit={handleSubmit}>
              <label className="flex flex-col gap-2">
                <span className="text-sm text-neutral-600">Email Address</span>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="border border-neutral-300 rounded-xl px-4 py-3 text-base focus:outline-none focus:ring-2 focus:ring-neutral-800"
                  placeholder="partner@company.com"
                  required
                  disabled={loading}
                />
              </label>

              {error && (
                <div className="mt-3 text-sm text-red-600 bg-red-50 border border-red-200 rounded-xl px-4 py-3">
                  {error}
                </div>
              )}

              {message && (
                <div className="mt-3 text-sm text-green-600 bg-green-50 border border-green-200 rounded-xl px-4 py-3">
                  {message}
                </div>
              )}

              <div className="mt-6 flex justify-center">
                <Button
                  variant="primary"
                  type="submit"
                  disabled={loading || !email}
                  className="text-base py-3 h-auto w-auto px-8"
                  text={loading ? "Sending..." : "Send Reset Link"}
                />
              </div>

              <div className="mt-4 text-center">
                <a
                  href="/"
                  className="text-sm text-neutral-600 hover:text-neutral-900 underline"
                >
                  Back to Login
                </a>
              </div>
            </form>
          </div>

        </div>
      </section>

      {/* Footer */}
      <footer className="px-6 sm:px-12 mt-24 mb-10">
        <div className="max-w-5xl mx-auto flex items-center justify-between text-[12px] text-neutral-500">
          <div>By all means, accelerate.</div>
          <div>🏴</div>
        </div>
      </footer>
    </main>
  );
}

